<template>
  <div>
    <el-input
      class="filter-tree-input"
      v-model="filterText"
      clearable
      size="small"
      placeholder="请输入关键字进行过滤"
      @input="handleInputFilter"
    />
    <el-tree
      class="mt-2"
      ref="tree"
      :data="treeData"
      default-expand-all
      node-key="index"
      :props="defaultProps"
      :filter-node-method="filterNode"
      :default-checked-keys="['0']"
      :highlight-current="true"
      :check-strictly="true"
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
    >
      <div
        slot-scope="{ node, data }"
        :class="['ellipsis', 'nameWrap', { 'selected-node': checkedNodes.includes(data.id) }]"
      >
        <el-tooltip
          :content="node.label"
          placement="right"
          :disabled="node.label.length <= 25"
        >
          <div class="ellipsis py-1 name">{{ node.label }}</div>
        </el-tooltip>
        <!-- 删除按钮：仅 adGroup 和 ads 级别显示，且同级节点数 > 1 -->
        <i
          v-if="data.level !== 'campaign' && node.parent && node.parent.childNodes.length > 1"
          class="el-icon-delete delete-btn"
          @click.stop="handleDeleteNode(data, node)"
        />
      </div>
    </el-tree>
  </div>
</template>
<script>
export default {
  props: {
    treeData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filterText: '',
      checkedNodes: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
    };
  },
  methods: {
    /**筛选 */
    filterNode(value, data) {
      if (!value) return true; // 如果没有过滤条件，则显示所有节点
      return data.name.indexOf(value) !== -1; // 根据过滤条件判断是否显示节点
    },
    /**输入框输入 */
    handleInputFilter() {
      this.$refs.tree.filter(this.filterText); // 当输入框内容变化时调用filter方法1
    },
    /**点击节点 */

    handleNodeClick(data, node, nodeComponent) {
      //   点击广告组的时候，识别广告系列的竞价策略，根据广告系列的竞价策略设置组的
      if (data.level == 'adGroup') {
        data.campaignBidStrategy = node.parent.data.bidStrategy;
        data.campaignBidAmount = node.parent.data.bidAmount;
        data.campaignMsg = { promotionInfo: node.parent.data.promotionInfo };
      }
      if (data.level == 'ads') {
        data.keywordList = node.parent.data.groupCriterion.keywordList;
      }
      this.commonChange(data);
      this.highlightNode(data.index);
    },
    highlightNode(key) {
      this.$refs.tree.setCheckedKeys([key]);
    },
    /**设置默认值 */
    setDefaultData(data) {
      this.selectedLevel = data.level;
      this.$emit('setCurrentData', data);
    },
    commonChange(data) {
      console.log(data);
      //   this.$emit('setCurrentData', data);
      this.$emit('validateData', this.selectedLevel, (isValid) => {
        if (isValid) {
          // 如果校验不通过，恢复到之前选中的节点
          this.selectedLevel = data.level;
          this.$emit('setCurrentData', data);
        } else {
        }
      });
    },
    /**删除节点二次确认 */
    handleDeleteNode(data, node) {
      const tipText = data.level === 'adGroup' ? '该广告组及其所有广告' : '该广告';
      this.$confirm(`确定要删除${tipText}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$emit('delete-node', { data, level: data.level });
        })
        .catch(() => {});
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
::v-deep .el-tree-node__content {
  padding-right: 10px;
  line-height: 1.8;
  height: auto;
  .el-tree-node {
    white-space: wrap;
  }
  .nameWrap {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    padding-right: 16px;
    .name {
      flex: 1;
      min-width: 0; /* 让 ellipsis 在 flex 子项中生效 */
    }

    /* 删除按钮默认隐藏，固定在右侧 */
    .delete-btn {
      visibility: hidden;
      color: #f56c6c;
      cursor: pointer;
      font-size: 14px;
      flex-shrink: 0;
      margin-left: 4px;
      padding: 2px;
      position: absolute;
      top: 6px;
      right: 10px;
      &:hover {
        color: #f23c3c;
      }
    }

    /* hover 时显示删除按钮 */
    &:hover .delete-btn {
      visibility: visible;
    }
  }
  .name {
  }
}
</style>
